import { useState, forwardRef, ForwardedRef, useImperativeHandle } from "react";
import UnsavedChangesModal from "./edit-quiz-modals/UnsavedChangesModal";

export type UnsavedChangesModalWrapperRef = {
	open: () => void;
	close: () => void;
};

type Props = {
	onConfirm: () => void;
};

export const UnsavedChangesModalWrapper = forwardRef(function UnsavedChangesModalWrapper(
	{ onConfirm }: Props,
	ref: ForwardedRef<UnsavedChangesModalWrapperRef>,
) {
	const [openModal, setOpenModal] = useState(false);

	useImperativeHandle(ref, () => ({
		open: () => setOpenModal(true),
		close: () => setOpenModal(false),
	}));

	return openModal ? <UnsavedChangesModal onClose={() => setOpenModal(false)} onConfirm={onConfirm} inLms /> : null;
});

export default UnsavedChangesModalWrapper;
